/* EFL customer pricing helpers — shared by PDP spec snippets.
   Company metafields are authoritative. Ajax product JSON only exposes retail
   price, so custom price-level buyers are sent to the PDP for their exact price. */
(function() {
  window.EFL = window.EFL || {};

  window.EFL.formatMoney = function(cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  window.EFL.customerPrice = function(cents) {
    var cfg = window.eflCustomerPricing || {};
    if (!cfg.isB2B) return cents;
    if (cfg.hasCustomLevel) return null;
    var wholesale = Math.round(cents / 3);
    var pct = Number(cfg.insiderPct) || 0;
    return pct > 0 ? Math.round(wholesale * (100 - pct) / 100) : wholesale;
  };
})();
